"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _SimpleProblemLoggingInFormComponent = _interopRequireDefault(require("./SimpleProblemLoggingInFormComponent"));
var _userActions = require("../../redux/actions/userActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SimpleProblemLoggingInForm = (0, _reduxForm.reduxForm)({
  form: 'forgotPassword',
  onSubmit: function onSubmit(payload, dispatch) {
    var resetPassword = payload.resetPassword,
      Email = payload.Email;
    if (resetPassword) return dispatch((0, _userActions.sendResetPasswordEmail)(Email));
    return dispatch((0, _userActions.resendVerificationEmail)({
      Email: Email
    }));
  },
  enableReinitialize: true
})(_SimpleProblemLoggingInFormComponent["default"]);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendResetPasswordEmail: _userActions.sendResetPasswordEmail,
    resendVerificationEmail: _userActions.resendVerificationEmail
  };
};
var SimpleProblemLoggingInFormContainer = (0, _reactRedux.connect)(null, mapDispatchToProps())(SimpleProblemLoggingInForm);
var _default = exports["default"] = SimpleProblemLoggingInFormContainer;